import styled from 'styled-components';
import { ReactComponent as AlertRulesIcon } from '@elementary/common-ui/assets/20x20/alert-rules.svg';
import { ReactComponent as NotificationsIcon } from '@elementary/common-ui/assets/20x20/notifications.svg';
import { ReactComponent as PlusIcon } from '@elementary/common-ui/assets/20x20/plus.svg';
import {
  Breadcrumbs,
  Button,
  Flex,
  FlexColumn,
  FlexSpace,
  Tab,
  Tabs,
} from '@elementary/common-ui/components';
import useEnvPermission from '@elementary/common-ui/hooks/useEnvPermission';
import { Tooltip } from '@mui/material';

export type AlertRulesTab = 'alert-rules' | 'incidents-digest';

const TabsStyled = styled(Tabs)`
  border-bottom: 1px solid ${({ theme }) => theme.palette.common.gray8};
`;

type Props = {
  disabledCreate: boolean;
  onDrawerOpen: () => void;
  selectedTab: AlertRulesTab;
  onTabChange: (tab: AlertRulesTab) => void;
  showDigestTab: boolean;
};

const Header = ({
  disabledCreate,
  onDrawerOpen,
  selectedTab,
  onTabChange,
  showDigestTab,
}: Props) => {
  const hasPermission = useEnvPermission();

  const canCreate =
    selectedTab === 'alert-rules'
      ? hasPermission('EDIT_ALERT_RULES')
      : hasPermission('EDIT_DIGEST_RULES');

  const createLabel =
    selectedTab === 'alert-rules' ? 'Create alert rule' : 'Create digest rule';

  return (
    <FlexColumn sx={{ gap: 2 }}>
      <FlexSpace>
        <Breadcrumbs
          items={['Configuration', 'Alert Rules']}
          showTreeButton={false}
        />
        {canCreate && (
          <Tooltip
            disableHoverListener={!disabledCreate}
            title="Connect your messaging app or incident management service to start getting alerts from Elementary."
          >
            <div>
              <Button
                startIcon={<PlusIcon />}
                disabled={disabledCreate}
                onClick={onDrawerOpen}
              >
                {createLabel}
              </Button>
            </div>
          </Tooltip>
        )}
      </FlexSpace>

      <Flex>
        <TabsStyled
          value={selectedTab}
          onChange={(_, val) => onTabChange(val as AlertRulesTab)}
          orientation="horizontal"
        >
          <Tab
            label="Alert Rules"
            value="alert-rules"
            $size="small"
            iconPosition="start"
            icon={<AlertRulesIcon width={20} />}
          />
          {showDigestTab && (
            <Tab
              label="Incidents Digest"
              value="incidents-digest"
              $size="small"
              iconPosition="start"
              icon={<NotificationsIcon width={20} />}
            />
          )}
        </TabsStyled>
      </Flex>
    </FlexColumn>
  );
};

export default Header;
